import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/pages/startpage/src/assets/google-play-badge-en.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')